export const CACHE_NAME = 'focusBear';
export const CACHE_CATEGORY = {
  YOUTUBE_URL: 'youtube_url'
};

export const addYouTubeURLMetaDataIntoCache = (
  cacheCategory: string,
  response: Response
) => {
  if ('caches' in window) {
    caches.open(CACHE_NAME).then((cache) => {
      cache.put(cacheCategory, response);
    });
  }
};

export const getYouTubeURLMetaCacheData = async (): Promise<{
  videos_metadata: Array<{
    id?: string;
    title: string;
    duration: string;
    video_url: string;
  }>;
} | null> => {
  try {
    const response = await caches.match(CACHE_CATEGORY.YOUTUBE_URL);
    const data = response ? await response.json() : null;
    return data;
  } catch {
    return null;
  }
};
